import { helper } from '@/helper.js';

const state = {
  strains: [],
  rooms: [],
  plantBatches: [],
  items: [],
  packages: [],
  harvests: [],
  vegetativePlants: [],
  floweringPlants: [],
  growthPhases: [],
  plantBatchTypes: [],
  itemCategories: [],
  unitOfMeasurement: [],
  itemBrands: [],
  wasteTypes: [],
  adjustReasons: [],
  userData: null,
  allTodoList: null,
  activeTodoList: [],
  completedTodoList: [],
  user: { firstName: '', lastName: ''},
  recentNotifications: [],
  recentNotificationCount: 0
};

const getters = {
  getStrains: state => {
    return state.strains;
  },
  getRooms: state => {
    return state.rooms;
  },
  getPlantBatches: state => {
    return state.plantBatches;
  },
  getItems: state => {
    return state.items;
  },
  getPackages: state => {
    return state.packages;
  },
  getHarvests: state => {
    return state.harvests;
  },
  getVegetativePlants: state => {
    return state.vegetativePlants;
  },
  getFloweringPlants: state => {
    return state.floweringPlants;
  },
  getGrowthPhases: state => {
    return state.growthPhases;
  },
  getPlantBatchTypes: state => {
    return state.plantBatchTypes;
  },
  getItemCategories: state => {
    return state.itemCategories;
  },
  getUnitOfMeasurement: state => {
    return state.unitOfMeasurement;
  },
  getItemBrands: state => {
    return state.itemBrands;
  },
  getWasteTypes: state => {
    return state.wasteTypes;  
  },
  getAdjustReasons: state => {
    return state.adjustReasons;  
  },
  getUserData: state => {
    return state.userData;
  },
  getTodoList: state => {
    return state.allTodoList;
  },
  getRecentNotifications: state => {
    return state.recentNotifications;
  },
  getRecentNotificationCount: state => {
    return state.recentNotificationCount;
  }
};

const actions = {
  getAllPlantBatches: ({ commit }) => {
    return helper.getPlantBatches().then(function(data) {
      commit('setPlantBatches', data);
    });
  },
  getAllStrains: ({ commit }) => {
    return helper.getStrains().then(function(data) {
      commit('setStrains', data);
    });
  },
  getAllRooms: ({ commit }) => {
    return helper.getRooms().then(function(data) {
      commit('setRooms', data);
    });
  },
  getAllItems: ({ commit }) => {
    return helper.getItems().then(function(data) {
      commit('setItems', data);
    });
  },
  getAllPackages: ({ commit }) => {
    return helper.getPackages().then(function(data) {
      commit('setPackages', data);
    });
  },
  getAllVegetativePlants: ({ commit }) => {
    return helper.getVegetativePlants().then(function(data) {
      commit('setVegetativePlants', data);
    });
  },
  getAllFloweringPlants: ({ commit }) => {
    return helper.getFloweringPlants().then(function(data) {
      commit('setFloweringPlants', data);
    });
  },
  getAllHarvests: ({ commit }) => {
    return helper.getHarvests().then(function(data) {
      commit('setHarvests', data);
    });
  },
  getAllGrowthPhases: ({ commit }) => {
    return helper.getGrowthPhases().then(function(data) {
      commit('setGrowthPhases', data);
    });
  },
  getAllPlantBatchTypes: ({ commit }) => {
    return helper.getPlantBatchTypes().then(function(data) {
      commit('setPlantBatchTypes', data);
    });
  },
  getAllItemCategories: ({ commit }) => {
    return helper.getItemCategories().then(function(data) {
      commit('setItemCategories', data);
    });
  },
  getAllUnitOfMeasurement: ({ commit }) => {
    return helper.getUnitOfMeasurement().then(function(data) {
      commit('setUnitOfMeasurement', data);
    });
  },
  getAllItemBrands: ({ commit }) => {
    return helper.getItemBrands().then(function(data) {
      commit('setItemBrands', data);
    });
  },
  getAllWasteTypes: ({ commit }) => {
    return helper.getWasteTypes().then(function(data) {
      commit('setWasteTypes', data);
    });
  },
  getAllAdjustReasons: ({ commit }) => {
    return helper.getAdjustReasons().then(function(data) {
      commit('setAdjustReasons', data);
    });
  },
  getAllUserData: ({ commit }) => {
    return helper.getUserData().then(function(data) {
      if (data.status === 'success') {
        commit('setUserData', data.data);
      }
    });
  },
  getAllTodoList: ({ commit }) => {
    return helper.getTodoList().then(function(data) {
      commit('setTodoList', data);
    });
  },
  getRecentNotificationList: ({ commit }) => {
    return helper.getRecentNotificationList().then(function(data) {
      commit('setRecentNotificationList', data);
    });
  },
  getRecentNotificationCount: ({ commit }) => {
    return helper.getRecentNotificationCount().then(function(data) {
      let result = 0;
      if (data) {
        result = Object.keys(data).length;
      }
      commit('setRecentNotificationCount', result);
    });
  },
  clearData: ({commit}) => {
    commit('clearData');
  }
};

const mutations = {
  setPlantBatches: (state, plantBatches) => {
    state.plantBatches = plantBatches;
  },
  setStrains: (state, strains) => {
    state.strains = strains;
  },
  setRooms: (state, rooms) => {
    state.rooms = rooms;
  },
  setItems: (state, items) => {
    state.items = items;
  },
  setPackages: (state, packages) => {
    state.packages = packages;
  },
  setVegetativePlants: (state, vegetativePlants) => {
    state.vegetativePlants = vegetativePlants;
  },
  setFloweringPlants: (state, floweringPlants) => {
    state.floweringPlants = floweringPlants;
  },
  setHarvests: (state, harvests) => {
    state.harvests = harvests;
  },
  setGrowthPhases: (state, growthPhases) => {
    state.growthPhases = growthPhases;
  },
  setPlantBatchTypes: (state, types) => {
    state.plantBatchTypes = types;
  },
  setItemCategories: (state, itemCategories) => {
    state.itemCategories = itemCategories;
  },
  setUnitOfMeasurement: (state, measurements) => {
    state.unitOfMeasurement = measurements;
  },
  setItemBrands: (state, brands) => {
    state.itemBrands = brands;
  },
  setWasteTypes: (state, types) => {
    state.wasteTypes = types;
  },
  setAdjustReasons: (state, reasons) => {
    state.adjustReasons = reasons;
  },
  setRecentNotificationList: (state, notifictionList) => {
    state.recentNotifications = notifictionList;
  },
  setRecentNotificationCount: (state, notifictionsCount) => {
    state.recentNotificationCount = notifictionsCount;
  },
  setUserData: (state, userData) => {
    state.userData = userData;
    state.user.firstName = userData.user.firstName;
    state.user.lastName  = userData.user.lastName;
  },
  setTodoList: (state, list) => {
    state.allTodoList = list;
    state.activeTodoList = list.active;
    state.completedTodoList = list.completed;
  },
  clearData: (state) => {
    state.plantBatches = [];
    state.strains = [];
    state.rooms = [];
    state.items = [];
    state.packages = [];
    state.vegetativePlants = [];
    state.floweringPlants = [];
    state.harvests = [];
    state.growthPhases = [];
    state.plantBatchTypes = [];
    state.itemCategories = [];
    state.unitOfMeasurement = [];
    state.itemBrands = [];
    state.wasteTypes = [];
    state.adjustReasons = [];
    state.userData = null;
    state.allTodoList = null;
    state.recentNotifications = [];
    state.recentNotificationCount = 0;
  }
};

export const library = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};


// WEBPACK FOOTER //
// ./source/store/library.module.js